<div name="customerGridContainer">
     <div class="overlay" *ngIf="isLoading">
          <h1 class="heading" [innerHtml]="'Loading' | translator: 'base'">Loading...</h1>
          <img [alt]="'Loading' | translator: 'base'" />
     </div>


     <ag-grid-angular 
          (gridReady)="onGridReady($event)" 
          (gridSizeChanged)="smartSizeColumns()" 
          class="ag-theme-alpine w-100" 
          [columnDefs]="columnDefs" 
          [defaultColDef]="defaultColDef" 
          [rowData]="rowData$"
          [gridOptions]="gridOptions" 
          [overlayLoadingTemplate]="overlayLoadingTemplate"
          [overlayNoRowsTemplate]="overlayNoRowsTemplate" 
          [domLayout]="domLayout"
          rowSelection.mode="singleRow"
          (model-updated)="cleanModel()"
          [pagination]="true" 
          [paginationPageSize]="paginationPageSize"
          [paginationPageSizeSelector]="paginationPageSizeSelector" 
          rowModelType="clientSide"
          
          ></ag-grid-angular>

     <div class="psuedo-hidden" #pageVooDoo [innerHtml]="translate('Voodoo')">Voodoo||| DO NOT CHANGE TO display:none or
          translation won't be triggered and grid language will not change on language drop down change.</div>

     <ng-template #SubmitOrResubmitModal let-modal>
          <div class="modal-header">
               <h3 *ngIf="isSubmitStatus" id="submitOrResubmitModalTitle" class="modal-title"
                    [innerHtml]="'submitProbationModalTitle' | translator: 'customer'">
                    Probation Transaction
               </h3>
               <h3 *ngIf="isResubmitStatus" id="submitOrResubmitModalTitle" class="modal-title"
                    [innerHtml]="'resubmitProbationModalTitle' | translator: 'customer'"
                    id="resubmitProbationModalTitle">
                    Resubmit
               </h3>
          </div>
          <div class="modal-body">
               <p *ngIf="isSubmitStatus" class="modal-title mb-3" slot="header" id="submitProbationModalText"
                    [innerHtml]="'submitProbationModalText' | translator: 'customer'">
                    Submit a legible copy of the driver's disclosure and authorization form, once reviewed the driver's
                    PSP record is available.
               </p>
               <p *ngIf="isResubmitStatus" class="modal-title mb-3" slot="header" id="resubmitProbationModalText"
                    [innerHtml]="'resubmitProbationModalText' | translator: 'customer'">>
                    The previously submitted disclosure and authorization form did not meet requirements.
               </p>

               <p *ngIf="isSubmitStatus" class="mt3 mb3"
                    [innerHtml]="'submitProbationModalText1' | translator: 'customer'">
                    The form must include the driver's name, driver's signature, FMCSA-required disclosure and
                    authorization language, and must be dated on or prior to the date of the PSP record transaction.
               </p>
               <p *ngIf="isResubmitStatus" class="mt3 mb3"
                    [innerHtml]="'resubmitProbationModalText1' | translator: 'customer'">
                    The form must include the driver's name, driver's signature, FMCSA-required disclosure and
                    authorization language, and must be dated on or prior to the date of the PSP record transaction.
                    This form failed to meet at least one of these requirements.
               </p>

               <p [innerHtml]="'probationModalText2' | translator: 'customer'">
                    How to submit disclosure and authorization forms:
               </p>

               <ul>
                    <li [innerHtml]="'UploadText' | translator: 'customer'">
                         Upload file online. Acceptable files formats: PDF, JPEG, and PNG.
                    </li>
                    <li [innerHtml]="'probationModalText3' | translator: 'customer'">
                         Fax the form(s) to 703-841-6370. You must include a cover sheet with your company name.
                    </li>
                    <li [innerHtml]="'probationModalText4' | translator: 'customer'">
                         Email the form(s) to PSPaudit&#64;tylertech.com. Select the email option below and a populated
                         email
                         will open for you.
                    </li>
               </ul>
               <p *ngIf="isResubmitStatus" [innerHtml]="'resubmitProbationModalText6' | translator: 'customer'">
                    Please resubmit or contact the PSP Customer Service Team at PSPhelp&#64;tylertech.com or call
                    toll-free
                    at 877-642-9499, Monday through Thursday from 8 AM to 6 PM ET, and on Friday from 8 AM to 5 PM ET.
               </p>
               <p *ngIf="isSubmitStatus" [innerHtml]="'submitProbationModalText6Title' | translator: 'customer'">
                    If you have questions please contact the PSP Customer Service Team at PSPhelp&#64;tylertech.com or
                    call
                    toll-free at 877-642-9499, Monday through Thursday from 8 AM to 6 PM ET, and on Friday from 8 AM to
                    5 PM ET.
               </p>
               <fieldset>
                    <p [innerHtml]="'probationModalText7' | translator: 'customer'">
                         To upload your forms online, generate a populated email or fax cover sheet, please select the
                         appropriate option below and hit Ok.
                    </p>
                    <div class="form-check">
                         <label for="onlineSubmittal" class="form-check-label">
                              <input id="onlineSubmittal" class="form-check-input" type="radio" name="onlineSubmittal"
                                   [(ngModel)]="coversheetType" value="online" tabindex="1" />
                              <span [innerHtml]="'UploadInputText' | translator: 'customer'"
                                   [title]="'UploadInputText' | translator: 'customer'">Upload File Online</span>
                         </label>
                    </div>
                    <div class="form-check">
                         <label for="emailSelection" class="form-check-label">
                              <input id="emailSelection" class="form-check-input" name="emailSelection"
                                   [(ngModel)]="coversheetType" type="radio" value="email" />
                              <span [innerHtml]="'Email' | translator: 'base'"
                                   [title]="'Email' | translator: 'base'">Email</span>
                         </label>
                    </div>
                    <div class="form-check">
                         <label for="faxSelection" class="form-check-label">
                              <input id="faxSelection" class="form-check-input" name="faxSelection"
                                   [(ngModel)]="coversheetType" type="radio" value="fax" />
                              <span [innerHtml]="'probationModalText9' | translator: 'customer'"
                                   [title]="'probationModalText9' | translator: 'customer'">Fax Cover Sheet</span>
                         </label>
                    </div>
                    <input type="hidden" />
               </fieldset>
          </div>
          <div class="modal-footer">
               <button class="btn btn-primary ms-2" [disabled]="coversheetType.length === 0 || coversheetType === null"
                    (click)="executeCoverSheet()" [title]="'ok_button' | translator: 'base'"
                    [innerHtml]="'ok_button' | translator: 'base'" id="okay" name="okay">
                    OK
               </button>
               <button class="btn btn-outline-primary" (click)="cancelCoverSheet()"
                    [title]="'cancel_button' | translator: 'base'" id="btnMakeDefaultCancel"
                    name="btnMakeDefaultCancel">
                    <span [innerHtml]="'cancel_button' | translator: 'base'">Cancel</span>
               </button>
          </div>
     </ng-template>

     <ng-template #UploadModal let-modal>
          <div class="modal-header">
               <h3 id="uploadModalTitle" class="modal-title" slot="header">
                    <span [innerHtml]="'uploadModalTitle' | translator: 'audit'">Add document for driver:</span>
                    {{currentTransaction.lastName}}
               </h3>
          </div>
          <div class="modal-body">
               <div class="overlay" *ngIf="isUploading">
                    <h1 class="heading" [innerHtml]="'Processing' | translator: 'base'">Processing...</h1>
               </div>
               <p [innerHtml]="'UploadModalText1' | translator: 'audit'">Add one or more files here to complete your
                    document submission.
               </p>
               <div class="alert alert-warning">
                    <span class="pl-1" [innerHtml]="'formsText5' | translator: 'audit'"> The driver's name, signature,
                         and date must be included on the forms. Please remove or black out any other personally
                         identifiable information, like date of birth, social security number, license number, etc.
                    </span>
               </div>
               <h4 [innerHtml]="'uploadedFilesHeader' | translator: 'audit'" class="h5">Uploaded files</h4>
               <p class="text-center no-files-message" *ngIf="probationDocuments.length === 0"
                    [innerHtml]="'noDocAttempts' | translator: 'audit'">No files uploaded yet.</p>
               <div class="modal-submitted-documents" *ngIf="probationDocuments.length > 0">
                    <table class="table table-vcr table-light table-collapsible">
                         <thead>
                              <tr>
                                   <th scope="col" [innerHtml]="'docHeaderCol1' | translator: 'audit'">Submitted By</th>
                                   <th scope="col" [innerHtml]="'docHeaderCol2' | translator: 'audit'">Received</th>
                                   <th scope="col" [innerHtml]="'docHeaderCol3' | translator: 'audit'">Action</th>
                              </tr>
                         </thead>
                         <tbody>
                              <tr *ngFor="let doc of probationDocuments; let i = index;">
                                   <td class="text-break">
                                        <span class="cell-label"
                                             [innerHtml]="'docHeaderCol1' | translator: 'audit'">Submitted By</span>
                                        {{doc.creator}}
                                   </td>
                                   <td class="text-break">
                                        <span class="cell-label"
                                             [innerHtml]="'docHeaderCol2' | translator: 'audit'">Received</span>
                                        {{ doc.created | dateTimeFromIso | dateTimeToFormat:'MM/dd/yyyy' }}
                                   </td>
                                   <td>
                                        <span class="cell-label"
                                             [innerHtml]="'docHeaderCol3' | translator: 'audit'">Action</span>
                                        <button *ngIf="doc.mimeTypeId === 2 || doc.mimeTypeId === 4"
                                             class='btn btn-primary btn-sm me-2 mb-2'
                                             (click)="showPdfDocument(doc.documentId)"
                                             [title]="'View' | translator: 'driver'" [id]="'viewPdf' + doc.documentId">
                                             <span [innerHtml]="'View' | translator: 'driver'">View</span>
                                        </button>
                                        <button *ngIf="doc.mimeTypeId !== 2 || doc.mimeTypeId === 4"
                                             class='btn btn-primary btn-sm me-2 mb-2'
                                             (click)="showDocument(doc.documentId)"
                                             [title]="'View' | translator: 'driver'" [id]="'viewImg' + doc.documentId">
                                             <span [innerHtml]="'View' | translator: 'driver'">View</span>
                                        </button>
                                        <button (click)="removeDocument(doc.documentId)"
                                             [title]="'btnRemove' | translator: 'audit'"
                                             class="btn btn-danger btn-sm mb-2" [id]="'remove' + doc.documentId">
                                             <span [innerHtml]="'btnRemove' | translator: 'audit'">Remove</span>
                                        </button>
                                   </td>
                              </tr>
                         </tbody>
                    </table>
               </div>
               <h4 [innerHtml]="'addDocumentsHeader' | translator: 'audit'" class="h5">Add document(s)</h4>
               <div class="file-upload-container">
                    <label for="" class="file-upload-label d-block position-relative overflow-hidden">
                         <input type="file" class="file-upload-input bg-light form-control d-block overlayed"
                              accept=".jpg, .jpeg, .png, .pdf" multiple (change)="uploadDocuments($event)"
                              id="uploadDocumentsId">
                         <span class="file-upload-overlay overlayed">
                              <div class="text-center px-3" aria-describedby="uploadDocumentsId">
                                   <strong>
                                        <span [innerHtml]="'docUploadChooseOrDrop1' | translator: 'audit'">Choose
                                             File(s)</span>
                                        <span class="ms-1"
                                             [innerHtml]="'docUploadChooseOrDrop2' | translator: 'audit'">or drag and
                                             drop file(s) here.</span>
                                   </strong>
                              </div>
                         </span>
                         <span class="file-upload-overlay-focus overlayed pe-none"></span>
                    </label>
               </div>
               <div class="help-block pt-2 mb-3">
                    <span class="fw-bold" [innerHtml]="'AcceptableFormats' | translator: 'audit'">Acceptable formats are
                         PDF, JPG, and PNG.</span>
               </div>
          </div>
          <div class="modal-footer">
               <button class="btn btn-primary" (click)="completeDocumentUploads()"
                    [title]="'submitDocsBtn' | translator: 'audit'" id="btnMakeDefaultOk" name="btnMakeDefaultOk"
                    [disabled]="probationDocuments && probationDocuments.length === 0">
                    <span class="pr-2" [innerHtml]="'submitDocsBtn' | translator: 'audit'">Submit Document(s)</span>
               </button>
               <button class="btn btn-outline-primary me-2" (click)="cancelUploads()"
                    [title]="'cancel_button' | translator: 'base'" id="btnMakeDefaultCancel"
                    name="btnMakeDefaultCancel">
                    <span [innerHtml]="'cancel_button' | translator: 'base'">Cancel</span>
               </button>
          </div>
     </ng-template>

     <ng-template #InvalidFileTypeModal let-modal>
          <div class="modal-header">
               <h3 id="invalidFileTypeModalTitle" class="modal-title" slot="header">
                    <span [innerHtml]="'invalidFileTypeTitle' | translator: 'audit'">Invalid File Type</span>
               </h3>
          </div>
          <div class="modal-body">
               <div class="alert alert-warning">
                    <span [innerHtml]="'invalidFileTypeText' | translator: 'audit'">You can only upload PDF, JPG, PNG,
                         or JPEG files|
                    </span>
               </div>
          </div>
          <div class="modal-footer">
               <button class="btn btn-primary" [title]="'ok_button' | translator: 'customer'" name="okay"
                    (click)="closeInvalidFileTypeModal()">
                    <span [title]="'ok_button' | translator: 'base'"
                         [innerHtml]="'ok_button' | translator: 'customer'">OK</span>
               </button>
          </div>
     </ng-template>

     <ng-template #PendingUnderReviewModal let-modal>
          <div class="modal-header">
               <h3 id="pendingUnderReviewModalTitle" class="modal-title" slot="header"
                    [innerHtml]="'pendingUnderReviewModalTitle' | translator: 'customer'">
                    Under Review
               </h3>
          </div>
          <div class="modal-body">
               <div slot="body" id="underReviewModalText"
                    [innerHtml]="'pendingUnderReviewModalText' | translator: 'customer'">
                    The PSP customer service team is reviewing the driver disclosure and authorization form.
                    You will be notified via email when the PSP record is available to view.
               </div>
          </div>
          <div class="modal-footer">
               <button class="btn btn-primary" [title]="'OK' | translator: 'base'" name="okay"
                    (click)="dismissUnderReviewModal()">
                    <span [innerHtml]="'OK' | translator: 'base'">OK</span>
               </button>
          </div>
     </ng-template>

     <ng-template #StopMonitorConfirmModal let-modal>
          <div class="modal-header">
               <h3 id="stopMonitorConfirmModalTitle" class="modal-title" [innerHtml]="'stopMonitorConfirmModalTitle' | translator: 'customer'">Stop Monitoring</h3>
          </div>
          <div class="modal-body">
               <div class="alert alert-warning">
                    <strong [innerHtml]="'Warning' | translator: 'base'">Warning!</strong>&nbsp;&nbsp;<span [innerHtml]="'StopMonitorModalWarning' | translator: 'customer'">This expired transaction will be removed from your dashboard when monitoring is discontinued.</span>
               </div>
               <p [innerHtml]="'StopMonitorModalConfirm' | translator: 'customer'">Are you sure you want to stop monitoring this driver record?</p>
          </div>
          <div class="modal-footer">
               <button class="btn btn-outline-primary me-2" name="btnCancelStopMonitor" (click)="cancelStopMonitoring()">
                    <span [innerHtml]="'cancel_button' | translator: 'base'">Cancel</span>
               </button>
               <button class="btn btn-danger" name="btnConfirmStopMonitor" (click)="confirmStopMonitoring()">
                    <span [innerHtml]="'StopMonitorModalBtn' | translator: 'customer'">Stop Monitoring</span>
               </button>
          </div>
     </ng-template>

     <div class="monitor-toast-container" aria-live="polite" aria-atomic="true">
          <ngb-toast *ngIf="showMonitorToast" [autohide]="true" [delay]="5000" (hidden)="showMonitorToast=false">
               <ng-template ngbToastHeader>
                    <strong class="me-auto" [innerHtml]="'MonitorToastTitle' | translator: 'customer'">Monitor Updated</strong>
               </ng-template>
               <span *ngIf="monitorToastOptIn"><span [innerHtml]="'MonitorToastOptInPrefix' | translator: 'customer'">Monitoring successfully added to the</span> {{monitorToastLastName}} <span [innerHtml]="'MonitorToastOptInSuffix' | translator: 'customer'">record.</span></span>
               <span *ngIf="!monitorToastOptIn"><span [innerHtml]="'MonitorToastOptOutPrefix' | translator: 'customer'">The</span> {{monitorToastLastName}} <span [innerHtml]="'MonitorToastOptOutSuffix' | translator: 'customer'">record is no longer being monitored.</span></span>
          </ngb-toast>
          <ngb-toast *ngIf="showMonitorErrorToast" [autohide]="true" [delay]="8000" (hidden)="showMonitorErrorToast=false" class="bg-danger text-white">
               <ng-template ngbToastHeader>
                    <strong class="me-auto" [innerHtml]="'MonitorToastErrorTitle' | translator: 'customer'">Monitor Update Failed</strong>
               </ng-template>
               <span *ngIf="monitorErrorToastIs401" [innerHtml]="'MonitorToastError401' | translator: 'customer'">Your session has expired. Please sign in again.</span>
               <span *ngIf="monitorErrorToastIs403"><span [innerHtml]="'MonitorToastError403Prefix' | translator: 'customer'">Customer: </span>{{customerId}}<span [innerHtml]="'MonitorToastError403Middle' | translator: 'customer'"> attempted illegal access on transaction: </span>{{monitorErrorToast403AuthCode}}.</span>
               <span *ngIf="!monitorErrorToastIs401 && !monitorErrorToastIs403" [innerHtml]="'MonitorToastError500' | translator: 'customer'">An error occurred updating the monitor status. Please try again or contact support.</span>
          </ngb-toast>
     </div>

</div>